import MDBadge from 'components/MDBadge'

export const statuses = {
    new: {
        text: 'חדש',
        color: 'light',
    },
    ready: {
        text: 'מוכן',
        color: 'warning',
    },
    pending: {
        text: 'ממתין לאישור',
        color: 'warning',
    },
    compiled: {
        text: 'נעול',
        color: 'secondary',
    },
    sent: {
        text: 'שודר',
        color: 'info',
    },
    invalid: {
        text: 'לא תקין',
        color: 'error',
    },
    missing_details: {
        text: 'חסרים פרטים',
        color: 'error',
    },
    valid: {
        text: 'תקין',
        color: 'success',
    },
    empty: {
        text: 'ריק',
        color: 'info',
    },
    cleared: {
        text: 'נסלק',
        color: 'success',
    },
    canceled: {
        text: 'בוטל',
        color: 'info',
    },
    rejected: {
        text: 'נפסל',
        color: 'error',
    },
    declined: {
        text: 'סורב',
        color: 'error',
    },
    draft: {
        text: 'טיוטה',
        color: 'secondary',
    },
    published: {
        text: 'פורסמה',
        color: 'success',
    },
    default(text) {
        return {
            text,
            color: 'info',
        }
    },
}

function StatusBadge({ status, ...rest }) {
    const normalizedStatus = status?.toLowerCase()

    const { text, color } =
        normalizedStatus && statuses.hasOwnProperty(normalizedStatus)
            ? statuses[normalizedStatus]
            : statuses.default(status)

    return text && (
        <MDBadge
            badgeContent={text}
            color={color}
            circular={true}
            variant="contained"
            size="lg"
            {...rest}
        />
    )
}

export default StatusBadge
